module.exports = __webpack_public_path__ + "media/images/cbs_logo-75cba9006a811da37181cd93abe8817e.svg";